import React from 'react';

const Linkedin = (props) => (
  <span {...props}>
    <svg width="28" height="28" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31 16C31 24.2843 24.2843 31 16 31C7.71573 31 1 24.2843 1 16C1 7.71573 7.71573 1 16 1C24.2843 1 31 7.71573 31 16ZM32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16ZM10.9592 10.8985C12.0412 10.8985 12.9184 10.0258 12.9184 8.94924C12.9184 7.8727 12.0412 7 10.9592 7C9.87716 7 9 7.8727 9 8.94924C9 10.0258 9.87716 10.8985 10.9592 10.8985ZM12.5918 23V12.3604H9.32653V23H12.5918ZM17.9796 12.3604H14.7143V23H17.9796V17.6802C17.9796 16.0964 18.4694 14.9594 20.0204 14.9594C21.5714 14.9594 21.7347 16.4213 21.7347 16.7462V17.1523V23H25V18.9797V17.1523V16.1371C25 13.6193 23.7347 12.0761 21.2041 12.0761C19.2879 12.0761 18.3312 13.2869 17.9796 13.8748V12.3604Z"
        fill="currentColor"
      />
    </svg>
  </span>
);

export default Linkedin;
